import { render, staticRenderFns } from "./YoutubeCommentItem.vue?vue&type=template&id=8528437e&scoped=true&"
import script from "./YoutubeCommentItem.vue?vue&type=script&lang=js&"
export * from "./YoutubeCommentItem.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeCommentItem.vue?vue&type=style&index=0&id=8528437e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528437e",
  null
  
)

export default component.exports